<template>
  <ModalDefault modal_id="addOperatorModal"
                header="y"
                size="modal-md modal-dialog-scrollable"
                style_header=""
                :modal_header="getTranslations('expression_625')"
                :footer="operators.operator.channel_id > 0 && operators.operator.department_id > 0"
                icon="bx bx-support mr-1">
    <div class="px-2 py-2 pb-3" slot="body">
      <div>
        <div class=" d-flex">
          <div class="file-upload-center cursor-default w-100" style="align-items: center; align-self: center;">
            <div v-if="operator_error" class="col-12 text-center px-2">
              <div class="animated--grow-in alert alert-danger">
                <span>{{ getTranslations('expression_625') }}</span>
              </div>
            </div>
            <div v-if="limit_operator_error" class="col-12 text-center px-2">
              <div class="animated--grow-in alert alert-danger">
                <span>{{ getTranslations('expression_627') }}</span>
              </div>
            </div>
            <div class="d-block pt-2 px-2">
              <div class="animated--grow-in col-12 px-0">
                <label class="mb-0">{{ getTranslations('expression_4') }} </label>
                <div class="input-group mb-4">
                  <select @change.prevent="operators.operator.department_id = null" v-model="operators.operator.channel_id"
                          class="input_forms custom-select px-50">
                    <option :value="0" selected>{{ getTranslations('expression_7') }}</option>
                    <option v-for="channel in channels.data.filter(channel => users.user.channels_id.includes(channel.id))"
                            v-if="channel.plan && channel.plan[4] && getOperatorsArray('channel_id', channel.id).length < channel.plan[4].amount && channel.status_key === 1"
                            :key="channel.id"
                            :value="channel.id">
                      {{ channel.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div v-if="operators.operator.channel_id > 0" class="animated--grow-in col-12 px-0">
                <label class="mb-0">{{ getTranslations('expression_12') }} </label>
                <div class="input-group mb-4">
                  <select v-model="operators.operator.department_id" class="input_forms custom-select px-50"
                          id="addoperator_department">
                    <option :value="null" selected>{{ getTranslations('expression_124') }}</option>
                    <option v-for="department in getDepartmentsArray('channel_id', operators.operator.channel_id)"
                            :key="department.id"
                            :value="department.id">
                      {{ department.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="px-2 py-2 d-flex">
      <div>
          <span @click.prevent="addOperator"
                class="shadow-sm cursor_pointer animated--grow-in btn-secondary text-white py-2 px-3">
            <span>{{ getTranslations('expression_120') }}</span>
          </span>
      </div>
    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../../components/general/ModalDefault";
import $ from "jquery";
import {mapGetters, mapState} from "vuex";

export default {
  name: "ModalAddOperator",
  components: {
    ModalDefault,
  },
  data() {
    return {
      operator_error: false,
      limit_operator_error: false,
    }
  },
  computed: {
    ...mapState(['users', 'channels', 'wallets', 'leads', 'operators', 'configs', 'user_access_logs', 'user_logs']),
    ...mapGetters(['getChannelObject',
      'getDepartmentObject',
      'getUserObject',
      'getDepartmentsArray',
      'getOperatorsArray',
      'getLeadsArray',
      'getLeadObject',
      'getTranslation',
    ]),
  },
  methods: {
    addOperator() {
      if (this.operators.operator.channel_id > 0 && this.operators.operator.department_id > 0) {
        this.operators.operator.data = {
          user_id: this.operators.operator.user_id
        }
        this.$store.dispatch('addOperator', this.operators.operator)
        this.operators.operator.department_id = 0
        this.operators.operator.channel_id = 0
        this.operator_error = false
        this.limit_operator_error = false
        $('#addOperatorModal').modal('hide')
      } else {
        this.limit_operator_error = false
        this.operator_error = true
      }
    },
  }
}
</script>

<style scoped>

</style>
